import { useCallback } from 'react';

import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';

import ToolbarItem from '../components/ToolbarItem';

const EmojiPicker = () => {
  const { toggleEmojiPicker, setForceEditorFocus } = useQuillEditorContext();

  const handleEmojiPicker = useCallback(() => {
    toggleEmojiPicker?.();

    setForceEditorFocus?.(false);
  }, [toggleEmojiPicker, setForceEditorFocus]);

  return (
    <ToolbarItem
      onMouseDown={() => setForceEditorFocus?.(true)}
      ariaLabel={s__('QuillEditorAccessibility|Pick Emoji')}
      dataTestId="emoji-picker-icon"
      icon={<FontAwesomeIcon iconName="face-grin" height="16px" />}
      id="emoji-picker-icon"
      onClick={handleEmojiPicker}
      enableFontAwesomeIcon
    />
  );
};

export default EmojiPicker;
